import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class DeleteVideoCategoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/video-category/delete/',
      requesterInfo,
    })
  }

  public async deleteVideoCategory(id: number): Promise<boolean> {
    this.props.url = `${this.props.url}${id}`
    return await this.deleteAsync<boolean>()
  }
}
